module.exports = __webpack_public_path__ + "images/cb4651607ebf718153d8ab72d0b44ab6.svg";